import { inject, Injectable } from '@angular/core';
import { portalConst } from '@app/config';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PortalService {
  private readonly api = inject(ApiService);
  private url = `${portalConst.api.eclass}/v1`;

  public getUserGroups(entity_id: number): Observable<any> {
    return this.api.get<any[]>(`${this.url}/groupings?entity_id=${entity_id}`);
  }
}
